<div class="biometric">
	<div class="main-biometric-wrapper">
		<div class="p-l-20 p-r-20">
			<div class="title">
				Enable Biometrics
			</div>
			<div class="description">
				Setup login with FaceID or Fingerprint
			</div>
		</div>
	</div>
	<div class="biometric-container">
		<app-kamona-layout [minHeight]="'calc(100vh - 127px)'">
			<div content>
				<div style="display: flex; justify-content: space-between;
                flex-direction: column-reverse; height: calc(100vh - 127px)">
					<div>
						<div class="icon flex justify-center">
							<img src="assets/images/svgs/mobile-biometric-icon.svg">
						</div>
						<div class="biometric-note" style="padding-bottom: 23vh">
							Would you like to enable face biometrics
							for a more secure and faster login?
						</div>
						<div class="p-b-32">
							<div nz-row nzAlign="middle" nzJustify="space-between">
								<div nz-col nzSpan="12">
									<div (click)="cancel(true)"
										 class="back-btn">
										Not Now
									</div>
								</div>
								<div nz-col nzSpan="12">
									<div class="kamona-button-session">
										<app-kamona-custom-button
											(submitForm)="continue()"
											[isBlock]="true"
											text="Enable Biometrics">
										</app-kamona-custom-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</app-kamona-layout>
	</div>
</div>
